import React, { useRef } from 'react';
import { debounce } from 'debounce';

import Grid from '@material-ui/core/Grid';
import Paper from '@material-ui/core/Paper';
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';

import CourtDetails from '../quotes/CourtDetails';
import Spacer from '../../../app/common/ui/Spacer';
import Typography from '@material-ui/core/Typography'

const CaseInfoEdit = ({ caseInfo, onChange, onComplete }) => {
    const {
        id = 'WTAF!',
        // caseReference,
        info: {
            courtCase: {
                number: caseNumber = '',
                court = {}
            } = {},
            serviceUser: {
                name: vp = '',
                age = 0,
                // vulnerabilities = []
            } = {}
        } = {},
        // referrer,
        // work,
        // note
    } = caseInfo;

    const editRef = useRef(vp);
    const ageRef = useRef(age);

    const handleServiceUserNameChange = debounce(() => {
        const { value = '' } = editRef.current || {};

        caseInfo.info.serviceUser.name = value;

        onChange({
            id,
            key: 'serviceUser.name',
            value
        });

    }, 500);

    const handleAgeChange = debounce(() => {
        const { value = 0 } = ageRef.current || {};

        caseInfo.info.serviceUser.age = value;

        onChange({
            id,
            key: 'serviceUser.age',
            value
        });

    }, 500);

    const handleCaseNumberChange = value => {
        caseInfo.info.courtCase.number = value;

        onChange({
            id,
            key: 'courtCase.number',
            value
        });
    };

    const handleCourtChange = value => {
        caseInfo.info.courtCase.court = { ...value };

        onChange({
            id,
            key: 'courtCase.court',
            value
        });
    }


    return (
        <Grid container direction='column' spacing={1}>
            <Grid item>
                <Paper style={{ padding: '1rem' }}>
                    <Typography variant="h6" color="initial">Vulnerable Person Details</Typography>
                    <Grid item xs={12} md={4}>
                        <Spacer />
                        <TextField
                            onChange={handleServiceUserNameChange}
                            id=""
                            label="Name"
                            inputRef={editRef}
                            defaultValue={vp}
                            fullWidth
                        />
                    </Grid>
                    <Grid item xs={1}>
                    <Spacer />

                        <TextField onChange={handleAgeChange}
                            inputRef={ageRef}
                            defaultValue={age}
                            label="Age"
                            fullWidth
                            type="number"
                            inputProps={{
                                min: 0,
                                max: 118
                            }}
                        />
                    </Grid>

                </Paper>
            </Grid>
            <Grid item xs={12}>
                {/* <TextField onChange={handleCaseNumberChange}
                    inputRef={caseNumberRef}
                    defaultValue={caseNumber}
                    label="Court Case Number"
                    fullWidth
                /> */}
                <CourtDetails
                    court={court}
                    caseNumber={caseNumber}
                    onChange={handleCourtChange}
                    onCaseNumberChange={handleCaseNumberChange}
                />
            </Grid>
            <Grid item>
                <Button onClick={onComplete} variant="contained" color="primary" size="small" style={{ marginTop: '1rem' }} >
                    Back (There may be a brief pause while your changes are applied)
                </Button>
            </Grid>
        </Grid>
    );
};

export default CaseInfoEdit;